// Used in reports-sessions.component.html, teacher-class-students.component.html, reports-scores.component.html, resports-progress-table.component.html, and reports-standards.component.html

// Angular
import {
    Component,
    ChangeDetectionStrategy,
    Input,
    OnInit,
    OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";

// RXJS/Store
import { select, Store } from "@ngrx/store";
import * as RouterStore from "#core/router-store";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
    selector: "no-active-students",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: [
        "./no-active-students.component.scss",
        "../../../../teacher/teacher.component.scss",
    ],
    template: `
        <div fxLayout="column" fxLayoutAlign="center center">
            <img [src]="studentsIcon" />
        </div>
        <div class="content">
            <h3>No Students yet</h3>
            <p>Add a Student to introduce them to a new world!</p>
            <!-- Add Student Button -->
            <button
                mat-flat-button
                class="add-students-button"
                aria-label="Add Students to this Class"
                (click)="addStudent()"
                [routerLink]="['new']"
            >
                Add Student +
            </button>
        </div>
    `,
    standalone: false
})
export class NoActiveStudentsComponent implements OnInit, OnDestroy {
    studentsIcon = "./assets/images/share/studentsIcon.svg";
    @Input() classID?: number;
    private ngUnsubscribe = new Subject();

    constructor(
        private router: Router,
        private routerStore: Store<RouterStore.RouterStateUrl>
    ) {}

    ngOnInit() {
        this.routerStore
            .pipe(select(RouterStore.getRouterState))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((router) => {
                if (router) {
                    this.classID = parseInt(router.state.params.courseID, 10);
                }
            });
    }

    addStudent() {
        this.router.navigate([`teacher/classes/${this.classID}/students/new`]);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
